import {Component, input} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {FieldContainerComponent} from '@shared/form/field-container/field-container.component';
import {FieldBaseComponent} from '@shared/form/field-base.component';
import {BooleanFieldBaseComponent} from '@shared/form/boolean/boolean-field-base.component';

@Component({
  selector: 'app-toggle-switch-field',
  imports: [
    ReactiveFormsModule,
    FieldContainerComponent
  ],
  templateUrl: './toggle-switch-field.component.html',
  styleUrl: './toggle-switch-field.component.scss'
})
export class ToggleSwitchFieldComponent extends BooleanFieldBaseComponent {
}
